import {PostStatus} from '../enums';

export const getStatusOfPostCompany = (post) => {
  let status;
  if (post) {
    status = post.status;
    if (!post.isActive) {
      status = PostStatus.DeActivated;
    } else if (!(status && status.status)) {
      status = Object.values(PostStatus).find((f) => f.status === post.status);
    } else {
      status = {};
    }
  }
  return status;
};
